import { GuxTruncate } from "genesys-spark-components-react";
import "./RadialButton.less";
import { MarkdownInline } from "./Markdown";

export function RadialButton({
    selected,
    value,
    text,
    onChange,
    verticalAlign,
}: {
    selected: boolean | undefined;
    value: string;
    text: string | undefined;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    verticalAlign: boolean;
}) {
    return (
        <div className={`RadialButton ${verticalAlign ? "vertical" : ""}`}>
            <input
                className="Clickable"
                slot="input"
                type="radio"
                id={value}
                value={value}
                checked={selected}
                onChange={onChange}
            />
            <label className="Clickable" htmlFor={value}>
                <GuxTruncate max-lines={15}>
                    <MarkdownInline
                        markdownInlineText={text ?? ""}
                    ></MarkdownInline>
                </GuxTruncate>
            </label>
        </div>
    );
}
